/**
 * HR-managed onboarding fields set when HR creates/edits a joinee.
 */
export var HR_ONBOARDING_FIELD_KEYS = [
  "name",
  "email",
  "phoneNumber",
  "aadhaar",
  "pan",
  "companyName",
  "designation",
  "doj",
  "workLocation",
  "pf",
  "uan",
];

/**
 * Returns true when a field was pre-filled by HR and should not be edited
 * by the candidate.
 */
export function isHrLockedValue(value) {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === "string") {
    return value.trim() !== "";
  }
  if (typeof value === "number") {
    return !Number.isNaN(value);
  }
  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }
  return Boolean(value);
}

/**
 * Candidate forms: lock when HR already provided a value.
 * Admin forms: always editable.
 */
export function isHrLockedField(isAdmin, serverValue) {
  if (isAdmin) {
    return false;
  }
  return isHrLockedValue(serverValue);
}

/**
 * Snapshot HR-provided user profile values from API user record.
 */
export function pickHrOnboardingSnapshot(user) {
  if (!user || typeof user !== "object") {
    return {};
  }
  var snapshot = {};
  HR_ONBOARDING_FIELD_KEYS.forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(user, key)) {
      snapshot[key] = user[key];
    }
  });
  return snapshot;
}

/**
 * Keep HR-managed values from server when candidate loads drafts/edits forms.
 */
export function applyHrLockedFields(values, snapshot, isAdmin) {
  if (isAdmin || !values || !snapshot) {
    return values;
  }
  var next = Object.assign({}, values);
  HR_ONBOARDING_FIELD_KEYS.forEach(function (key) {
    if (isHrLockedValue(snapshot[key])) {
      next[key] = snapshot[key];
    }
  });
  if (
    isHrLockedValue(snapshot.designation) &&
    Object.prototype.hasOwnProperty.call(next, "employed_department")
  ) {
    next.employed_department = snapshot.designation;
  }
  if (
    isHrLockedValue(snapshot.doj) &&
    Object.prototype.hasOwnProperty.call(next, "doa")
  ) {
    next.doa = snapshot.doj;
  }
  return next;
}

/**
 * Minimum employer certificate fields HR must complete before review.
 */
export function isEmployerCertificateReady(cert) {
  if (!cert || typeof cert !== "object") {
    return false;
  }
  return Boolean(
    cert.date && String(cert.name_address_establishment || "").trim()
  );
}

/**
 * Minimum wage fields HR must complete before Form Q review.
 */
export function areFormQWagesReady(values) {
  if (!values || typeof values !== "object") {
    return false;
  }
  return Boolean(
    String(values.basicSalary || "").trim() &&
      String(values.total || "").trim()
  );
}
